import React, { useState } from 'react';

import { AppShell, createStyles } from '@mantine/core';
import BannerModal from 'components/banner/BannerModal';
import { useAuth } from 'context/auth-context';
import { useIsImmersive } from 'context/immersive-mode-context';
import { use100vh } from 'react-div-100vh';
import { Outlet } from 'react-router-dom';
import { INavLink } from 'routes/types';

import DemoGymCountdownBanner from './components/DemoGymCountdownBanner';
import Header from './components/Header';
import Navbar from './components/Navbar';

const useStyles = createStyles(() => ({
  content: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

type DesktopLayoutProps = {
  navLinks: INavLink[];
};

const DesktopLayout = ({ navLinks }: DesktopLayoutProps): JSX.Element => {
  const { classes } = useStyles();
  const { session } = useAuth();
  const isImmersive = useIsImmersive();

  const [headerOpened, setHeaderOpened] = useState(false);
  const height = use100vh();

  return (
    <AppShell
      navbarOffsetBreakpoint='sm'
      padding={0}
      h={height || undefined}
      fixed
      header={
        isImmersive ? undefined : (
          <Header opened={headerOpened} handleBurgerClick={() => setHeaderOpened(o => !o)} />
        )
      }
      navbar={isImmersive ? undefined : <Navbar opened={headerOpened} links={navLinks} />}
    >
      {!isImmersive && !!session?.demoGym && <DemoGymCountdownBanner demoGym={session.demoGym} />}
      <div className={classes.content}>
        <Outlet />
      </div>
      <BannerModal />
    </AppShell>
  );
};

export default DesktopLayout;
